module.exports = __webpack_public_path__ + "img/coming-soon.fd8e99c0.png";